import type {
  CheckAvailableDateUC,
  ScheduleRepository,
} from "@phurshell/psiapp-frontend-core/domain";

export class CheckAvailableDate implements CheckAvailableDateUC {
  constructor(private readonly scheduleRepo: ScheduleRepository) {}

  async execute(date: string) {
    const data = await this.scheduleRepo.getSpecificDaySchedules();
    return !data.some((elem) => elem.date === date && elem.blocked);
  }
}
